import { Component, computed, effect, OnInit, Signal } from '@angular/core'
import { MenuItem } from 'primeng/api'
import { Menubar } from 'primeng/menubar'
import { BadgeModule } from 'primeng/badge'
import { AvatarModule } from 'primeng/avatar'
import { CommonModule } from '@angular/common'
import { MenubarPopoverComponent } from './menubar-popover/menubar-popover.component'
import { ResponsiveLogoComponent } from '../commons/responsive-logo/responsive-logo.component'
import { DarkModeSwitchComponent } from '../commons/dark-mode-switch/dark-mode-switch.component'
import { AuthService } from '../../services/auth.service'
import { TranslateModule, TranslateService } from '@ngx-translate/core'
import { TScreenType } from '../../models/utils.model'
import { AdminRequestsQualificationService } from '../../services/portability-request.services/admin-requests-qualification.service'
import { ResponsiveService } from '../../services/responsive/responsive.service'
import { ButtonModule } from 'primeng/button'
import { Tooltip } from 'primeng/tooltip'

@Component({
  selector: 'app-header',
  imports: [
    Menubar,
    BadgeModule,
    AvatarModule,
    CommonModule,
    MenubarPopoverComponent,
    ResponsiveLogoComponent,
    DarkModeSwitchComponent,
    TranslateModule,
    ButtonModule,
    Tooltip,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  items: MenuItem[] | undefined
  screenType: Signal<TScreenType>
  clipboardIcon = 'pi pi-clipboard'

  constructor(
    private authService: AuthService,
    private translate: TranslateService,
    private responsiveService: ResponsiveService,
    private adminRequestsQualificationService: AdminRequestsQualificationService,
  ) {
    this.screenType = this.responsiveService.screenType

    effect(() => {
      if (this.authService.isLoggedIn()) {
        this.setNavbarItems()
      } else {
        this.items = []
      }
    })

    effect(() => {
      const role = this.authService.currentRole()
      if (role) {
        this.setNavbarItems()
      }
    })
  }

  get isLoggedIn() {
    return this.authService.isLoggedIn()
  }

  get currentRole() {
    return this.authService.currentRole()
  }

  logoSrc = computed(() => {
    const screenSize = this.responsiveService.screenSize()
    return screenSize === 'xs'
      ? 'assets/images/logo-sm.svg'
      : 'assets/images/logo-md.svg'
  })

  async setNavbarItems() {
    const qualificationCount =
      this.adminRequestsQualificationService.qualificationCount()

    if (this.isLoggedIn) {
      switch (this.currentRole) {
        case 'admin':
          this.translate
            .get([
              'NAVBAR.ADMIN.DASHBOARD.TITLE',
              'NAVBAR.ADMIN.MANDATARIES_MANAGEMENT.TITLE',
              'NAVBAR.ADMIN.REQUESTS_VALIDATION.TITLE',
              'NAVBAR.ADMIN.REQUESTS_QUALIFICATION.TITLE',
              'NAVBAR.MANDATARY.LINK.TITLE',
            ])
            .subscribe((translations) => {
              this.items = [
                {
                  label: translations['NAVBAR.ADMIN.REQUESTS_VALIDATION.TITLE'],
                  icon: 'pi pi-check',
                  routerLink: '/admin/portability-requests',
                },
                {
                  label:
                    translations['NAVBAR.ADMIN.REQUESTS_QUALIFICATION.TITLE'],
                  icon: 'pi pi-user-edit',
                  routerLink: '/admin/requests-qualification',
                  badge: qualificationCount ? String(qualificationCount) : '',
                },
                {
                  label: translations['NAVBAR.MANDATARY.LINK.TITLE'],
                },
              ]
            })
          break
        case 'mandatary':
          this.translate
            .get([
              'NAVBAR.MANDATARY.REQUESTS_LIST.TITLE',
              'NAVBAR.MANDATARY.PORTABILITY_REQUEST.TITLE',
              'NAVBAR.MANDATARY.LINK.TITLE',
            ])
            .subscribe((translations) => {
              this.items = [
                {
                  label: translations['NAVBAR.MANDATARY.REQUESTS_LIST.TITLE'],
                  icon: 'pi pi-list',
                  routerLink: '/mandatary/portability-requests',
                },
                {
                  label: translations['NAVBAR.MANDATARY.LINK.TITLE'],
                },
              ]
            })
          break
        default:
          this.items = []
          break
      }
    }
  }

  async onHandleCopyOktaTokenButton() {
    const token = await this.authService.getAccessToken()
    if (token) {
      navigator.clipboard.writeText(token)
      this.clipboardIcon = 'pi pi-copy'
    }

    setTimeout(() => {
      this.clipboardIcon = 'pi pi-clipboard'
    }, 2000)
  }
}
